export interface CertificationGroup {
  level: 'Professional' | 'Specialty' | 'Associate' | 'Foundational';
  items: readonly string[];
}

export const CERTIFICATION_GROUPS: readonly CertificationGroup[] = [
  {
    level: 'Professional',
    items: [
      'Solutions Architect – Professional',
      'DevOps Engineer – Professional',
    ],
  },
  {
    level: 'Specialty',
    items: [
      'Advanced Networking – Specialty',
      'Security – Specialty',
      'Machine Learning – Specialty',
    ],
  },
  {
    level: 'Associate',
    items: [
      'Solutions Architect – Associate',
      'Developer – Associate',
      'SysOps Administrator – Associate',
      'Data Engineer – Associate',
      'Machine Learning Engineer – Associate',
    ],
  },
  {
    level: 'Foundational',
    items: ['Cloud Practitioner', 'AI Practitioner'],
  },
];

export const CERTIFICATION_COUNT = CERTIFICATION_GROUPS.reduce(
  (sum, group) => sum + group.items.length,
  0
);
